import { render, staticRenderFns } from "./MozTransferCard.vue?vue&type=template&id=04707726&scoped=true&"
import script from "./MozTransferCard.vue?vue&type=script&lang=js&"
export * from "./MozTransferCard.vue?vue&type=script&lang=js&"
import style0 from "./MozTransferCard.vue?vue&type=style&index=0&id=04707726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04707726",
  null
  
)

export default component.exports